import React, { Component } from "react";
import "../../style/registerPage.css"
import BuildingContext from "../../contexts/Building";
import Error from "./Error";

class SimpleTextInput extends Component {
    static contextType = BuildingContext;
    p2e = (input) => {
        return input.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
    }
    a2e = (input) => {
        return input.replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d))
    }
    render() { return (
            <>
                <input type="text"
                       maxLength={this.props.maxLength}
                       className={`input form-control ${this.props.condition1 === false || this.props.condition2 === false ||
                       this.props.condition3 === false || this.props.condition4 === false || this.props.condition6 === false ||
                       this.props.condition7 === false || this.props.condition5 ? "is-invalid" : ""}`}
                       value={this.props.value}
                       inputMode={this.props.digitsOnly ? 'numeric' : undefined}
                       onChange={(e) => {
                           let value = this.p2e(this.a2e(e.target.value));
                           if (this.props.digitsOnly) {
                               value = value.replace(/[^0-9]/g, '');
                           }
                           if (this.props.maxLength != null && value.length > this.props.maxLength) {
                               value = value.slice(0, this.props.maxLength);
                           }
                           this.context.handleFields(value, this.props.fieldNameString, this.props.valueOfInputString);
                       }}
                       placeholder=" "
                />
                <label className="placeholder"  style={{right: this.props.condition1 === false || this.props.condition2 === false ||
                    this.props.condition3 === false || this.props.condition4 === false || this.props.condition6 === false || this.props.condition7 === false ||  this.props.condition5 ? '35px' : '12px'}}>
                    {
                        this.props.label
                    }
                    {
                        this.props.required
                            ? <span style={{color: 'red'}}>*</span>
                            : null
                    }
                </label>
                <Error
                    condition1={this.props.condition1 === false} // requiredError
                    condition2={this.props.condition2 === false} // phoneNumberError
                    condition3={this.props.condition3 === false} // homeTelError
                    condition4={this.props.condition4 === false} // numberOnlyError
                    condition6={this.props.condition6 === false} // mobile or home telephone number (for emergency calls)
                    condition7={this.props.condition7 === false} // emailReg
                    error1={'required'}
                    error2={'telephoneRegex'}
                    error3={'homeTelephoneReg'}
                    error4={'numberRequired'}
                    error6={'MobileOrHomeTelephoneReg'}
                    error7={'emailRegex'}
                />
            </>
        );
    }
}

export default SimpleTextInput;